const autocompleteCalendarFilter = {
  sites: 'Sites',
  users: 'Responsable / Revisado por',
  equipments: 'Tipo del Equipo',
  equipmentGroups: 'Grupo del Equipo',
  serviceTypes: 'Tipo de Servicio',
  frequencies: 'Periodicidad',
  areas: 'Departamentos',
  company: 'Terceras Empresas'

};

export default autocompleteCalendarFilter;
